// extracted by mini-css-extract-plugin
export default {"btnMinhaLista":"BtnLista_btnMinhaLista__Fw+wm","btnMinhaLista__small":"BtnLista_btnMinhaLista__small__yuV0o"};